module.exports = __webpack_public_path__ + "img/rk_gl.fae3259b.png";